var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.225 7.06l-5.391 5.303a.741.741 0 01-.545.226.782.782 0 01-.554-.242.797.797 0 01-.235-.54.711.711 0 01.235-.54l6.612-6.505a.864.864 0 01.309-.203c.108-.04.225-.059.35-.059.126 0 .243.02.351.06.109.039.212.106.31.202l6.611 6.504a.728.728 0 01.222.528.761.761 0 01-.222.553.773.773 0 01-1.115 0L12.79 7.06v11.67a.763.763 0 01-.782.77.763.763 0 01-.782-.77V7.06z",
    fill: "currentColor"
  })));
}
SvgUp.displayName = 'Up';
export default SvgUp;